import React from "react";
import styles from "./styles.module.scss";
import { ActionFont } from "./../fonts/index";
import { IButtonProps } from "./types";

export const ButtonVW = ({
  text,
  disabled,
  onClick,
  type,
  className
}: IButtonProps) => (
  <button
    className={styles.component + (className ? ` ${className}` : "")}
    {...{ disabled, onClick, type }}
  >
    <ActionFont>{text}</ActionFont>
  </button>
);
